<template>
    <div class="wrapper">

        <div
            v-if="!startedTransaction"
            class="center"
        >
            <div
                class="logo"
            >
                <img
                    src="../assets/logo.png"
                    width="300"
                    height="300"
                />
            </div>

            <div v-if="!pageRefreshed" class="form">
                <input autofocus v-model="code" @keypress.enter="run" class="input-text" type="text"
                    placeholder="Authorization code" />
                <button @click="run" class="button" type="button">OK</button>
            </div>

            <div v-if="pageRefreshed" class="form">
                <button @click="run" class="button" type="button">CLICK HERE TO REFRESH PAGE</button>
            </div>

            <div class="error" v-if="error">
                ⚠ {{ errorData.message }}
            </div>
        </div>

        <!-- header v-else class="loading">
            <h1 class="loading__text">
                Carregando <span>mural digital</span> <div class="lds-ellipsis"><div></div><div></div><div></div><div></div></div>
                <div class="loading-slider">
                    <ul class="loading-slider__messages">
                        <li class="loading-slider__message">mural digital</li>
                        li class="loading-slider__message">slides</li>
                        <li class="loading-slider__message">imagens</li>
                    </ul>
                </div>
            </h1>
        </header> -->

        <header class="loading-static" v-else-if="startedTransaction">
            <h1>
                <img src="../assets/logo.png" width="300" height="300" />
                <div class="loading-text">
                    Loading
                    <span v-if="slidesMediaCount > 0" class="loading-text-media">media</span>
                    <span v-else class="loading-text-media">settings</span>
                </div>
                <div v-if="slidesMediaCount > 0" class="loading-text-media">{{ slideLoadedMediaCount }} / {{ slidesMediaCount }}</div>
                <div class="lds-ellipsis"><div></div><div></div><div></div><div></div></div>
            </h1>
            <div
                class="slow-connection-message"
                v-if="slowConnection"
            >
                Loading may take a while...
            </div>
        </header>

        <div
            v-if="slowConnection"
            class="slow-connection-badge"
        >
            ⚠ Internet connection
        </div>

        <div class="credits-info-home">
            <div>v2.3.4 - 16/02/2023</div>
            <div>© 2023 Mural Digital by CakeCherries. All rights reserved.</div>
        </div>

    </div>
</template>
<script lang="js">
import { ref } from 'vue'
import { mapActions, mapState } from 'vuex'
export default {
    name: 'HomeView',

    computed: {
        ...mapState(['slides', 'loadedToken', 'loadedDevice', 'loadedSlidesData', 'loadedSlidesMedia', 'slowConnection', 'slidesMediaCount', 'slideLoadedMediaCount']),
    },

    methods: {
        ...mapActions(['authenticateDevice', 'loadSlides', 'loadSlidesMedia', 'loadCurrentWeather', 'loadCurrentTime']),
        async run() {
            if (!this.code) return
            this.startedTransaction = true
            try {
                await this.authenticateDevice(this.code.toUpperCase())
                await this.loadSlides()

                this.$store.commit('lastContentUpdate', new Date())

                if (this.slides.length <= 0) {
                    return this.$router.push({ name: 'wait' })
                } else {
                    this.$router.push({ name: 'viewer' })
                }

                await this.loadCurrentWeather()
                await this.loadCurrentTime()
                // await this.loadSlidesMedia()
            } catch (error) {
                console.log(error)
                this.startedTransaction = false
                this.error = true
                // this.pageRefreshed = false

                if (error.message === 'Failed to fetch') {
                    this.errorData = {
                        message: 'TV connection issue, please check the network'
                    }
                } else {
                    this.errorData = {
                        message: error.message
                    }
                }
            }
        }
    },

    mounted () {
        if (this.$route.query.code) {
            this.code = this.$route.query.code.toUpperCase()
            this.pageRefreshed = true
            this.run()
        }
    },

    setup() {
        const code = ref(null)
        const startedTransaction = ref(false)
        const error = ref(false)
        const errorData = ref(null)
        const pageRefreshed = ref(false)

        return {
            code,
            startedTransaction,
            error,
            errorData,
            pageRefreshed
        }
    }
}
</script>
<style>
html,
body {
    margin: 0;
    padding: 0;
}

@font-face {
    font-family: Questrial;
    src: url('../assets/fonts/Questrial-Regular.ttf') format("truetype");
}

@font-face {
    font-family: 'UniviaPro';
    src: local('Univia Pro Medium'), local('Univia-Pro-Medium'),
        url('../assets/fonts/UniviaPro-Medium.woff2') format('woff2'),
        url('../assets/fonts/UniviaPro-Medium.woff') format('woff'),
        url('../assets/fonts/UniviaPro-Medium.ttf') format('truetype');
    font-weight: 500;
    font-style: normal;
}

</style>
<style>
.wrapper {
    width: 100vw;
    height: 100vh;
    background: rgb(210, 210, 210);
    background: radial-gradient(circle, rgba(210, 210, 210, 1) 0%, rgba(172, 172, 172, 1) 100%);
    font-family: Questrial !important;
    display: flex;
    justify-content: center;
    align-items: center;
}

.center {
    padding: 30px 45px;
    border-radius: 10px;
    background-color: #FFFFFF;
    text-align: center;
    width: 460px;
    box-shadow: 0.1rem 0.6rem 1rem #989898;
    position: relative;
}

.form {
    margin-top: 20px;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    gap: 5px;
}

.input-text {
    display: block;
    margin: 0;
    padding: 0.8rem 1.6rem;
    color: inherit;
    min-width: 320px;
    font-family: Questrial;
    font-size: 1.6rem;
    font-weight: inherit;
    line-height: 1.8;
    border: none;
    border-radius: 0.4rem;
    outline: none;
    border: 1px solid #c9c9c9;
    text-transform: uppercase;
    text-align: center;
}

.button {
    display: block;
    margin: 0;
    padding: 0.8rem 1.6rem;
    color: inherit;
    font-family: Questrial;
    font-size: 1.6rem;
    font-weight: inherit;
    line-height: 1.8;
    border: none;
    border-radius: 0.4rem;
    color: #FFFFFF;
    background-color: #2b3074 !important;
    border: 1px solid #2b3074;
    cursor: pointer;
}

.loading {
    display: flex;
    align-items: center;
    jsutify-content: center;
}

.loading-static{
    text-align: center;
    font-weight: bold;
    color: #fff;
    font-size: 1.3rem;
}
.loading-text{
    font-size: 4rem;
    text-shadow: 0px 0px 2px rgba(0, 0, 0, 0.4);
}

.loading-text-media {
    color: #2b3074 !important;
}
.loading__text {
    flex: 1 1 100%;
    width: 100%;
    text-align: center;
    font-size: 4rem;
    font-weight: bold;
    color: #fff;
    text-shadow: 0px 0px 2px rgba(0, 0, 0, 0.4);
}

.loading-slider {
    display: inline-block;
    height: 1.5em;
    overflow: hidden;
    vertical-align: middle;
    -webkit-mask-image: linear-gradient(transparent, white, white, white, transparent);
    mask-image: linear-gradient(transparent, white, white, white, transparent);
    mask-type: luminance;
    mask-mode: alpha;
}

.loading-slider__messages {
    display: inline-block;
    margin: 0;
    padding: 0;
    list-style: none;
    /* -webkit-animation-name: messageslider;
    animation-name: messageslider;
    -webkit-animation-timing-function: ease-out;
    animation-timing-function: ease-out;
    -webkit-animation-iteration-count: infinite;
    animation-iteration-count: infinite;
    -webkit-animation-duration: 10s;
    animation-duration: 10s; */
}

.loading-slider__message {
    display: block;
    line-height: 1.3em;
    text-align: left;
    color: #2b3074 !important;
}

.lds-ellipsis {
    display: inline-block;
    position: relative;
    width: 80px;
    height: 80px;
}

.lds-ellipsis div {
    position: absolute;
    top: 33px;
    width: 13px;
    height: 13px;
    border-radius: 50%;
    background: #fff;
    animation-timing-function: cubic-bezier(0, 1, 1, 0);
}

.lds-ellipsis div:nth-child(1) {
    left: 8px;
    animation: lds-ellipsis1 0.6s infinite;
}

.lds-ellipsis div:nth-child(2) {
    left: 8px;
    animation: lds-ellipsis2 0.6s infinite;
}

.lds-ellipsis div:nth-child(3) {
    left: 32px;
    animation: lds-ellipsis2 0.6s infinite;
}

.lds-ellipsis div:nth-child(4) {
    left: 56px;
    animation: lds-ellipsis3 0.6s infinite;
}

.slow-connection-message{
    color: #2b3074 !important;
}

.slow-connection-badge {
    color: #ffffff;
    padding: 10px;
    background-color: red;
    border-radius: 10px;
    position: fixed;
    bottom: 5px;
}

.error {
    padding: 5px;
    background-color: red;
    color: #ffffff;
    font-family: Questrial;
    font-size: 18px;
    margin-top: 10px;
    border-radius: 14px;
}

.credits-info-home{
    font-family: UniviaPro;
    font-size: 11px;
    position: fixed;
    bottom: 2px;
    color: #000000;
    z-index: 999;
    display: flex;
    justify-content: space-between;
    width: 99%;
    padding: 0 10px;
}

@keyframes lds-ellipsis1 {
    0% {
        transform: scale(0);
    }

    100% {
        transform: scale(1);
    }
}

@keyframes lds-ellipsis3 {
    0% {
        transform: scale(1);
    }

    100% {
        transform: scale(0);
    }
}

@keyframes lds-ellipsis2 {
    0% {
        transform: translate(0, 0);
    }

    100% {
        transform: translate(24px, 0);
    }
}


@-webkit-keyframes messageslider {

    0%,
    27% {
        transform: translateY(0%);
    }

    33%,
    60% {
        transform: translateY(-25%);
    }

    66%,
    93% {
        transform: translateY(-50%);
    }

    100% {
        transform: translateY(-75%);
    }
}

@keyframes messageslider {

    0%,
    27% {
        transform: translateY(0%);
    }

    33%,
    60% {
        transform: translateY(-25%);
    }

    66%,
    93% {
        transform: translateY(-50%);
    }

    100% {
        transform: translateY(-75%);
    }
}
</style>